import React, { SetStateAction, useState } from "react";
import VerifiedIcon from "../../../Icons/VerifiedIcon";

interface props {
  activeStep: number;
  setActiveStep: React.Dispatch<SetStateAction<number>>;
  totalSteps: number;
  stepsTitle?: [];
  webClassName?: string;
  mobileClassName?: string;
  outerClassName?: string;
}

export const StepperComponent = ({
  activeStep,
  setActiveStep,
  totalSteps,
  stepsTitle,
}: props) => {
  return (
    <>
      {/* Mobile Stepper */}
      <div className={`flex mb-5  w-full`}>
        <ul className="flex justify-between w-full ">
          {Array.from({ length: totalSteps }, (_, index) => (
            <li
              className={` ${index + 1 == totalSteps ? "" : "flex-1"} `}
              key={index}
            >
              <div className="flex items-start">
                {activeStep > index ? (
                  <div
                    className="hover:cursor-pointer h-fit"
                    onClick={() => {
                      setActiveStep(index);
                    }}
                  >
                    <VerifiedIcon />
                  </div>
                ) : (
                  <button
                    className={`rounded-full bg-transparent border ${
                      activeStep === index
                        ? "border-brand-bgBlack border-[0.5px]"
                        : "border-[#5D5FEF] border-[0.5px]"
                    }  min-h-[26px] min-w-[26px]`}
                  >
                    {activeStep === index && (
                      <div className="rounded-full bg-black h-3 w-3"></div>
                    )}
                  </button>
                )}
                <div
                  className={`border-t-[1px] border-[#5D5FEF]  mt-3  w-full ${
                    index + 1 === totalSteps ? "hidden" : ""
                  }`}
                />
              </div>
              <div
                onClick={() => {
                  if (activeStep > index) setActiveStep(index);
                }}
                className="mt-3 -translate-y-[6px] hover:cursor-pointer"
              >
                <p
                  className={`font-openSans font-normal text-mobile-body-sm lg:text-[20px] leading-4 lg:leading-7 ${
                    activeStep + 1 > index
                      ? "text-brand-bgBlack"
                      : "text-brand-textLightGrey"
                  }  `}
                >
                  {/* {stepsTitle ? stepsTitle[index] : "Add Details"} */}
                </p>
                {/* <p
                  className={`font-openSans font-normal text-mobile-body-xsm lg:text-web-body-md leading-[13px] lg:leading-5 ${
                    activeStep + 1 > index
                      ? "text-brand-bgBlack"
                      : "text-brand-textLightGrey"
                  } `}
                >{`Step ${index + 1}`}</p> */}
              </div>
            </li>
          ))}{" "}
        </ul>
      </div>

      {/* Web stepper  */}
      <div
        className={`mr-10  bg-[url('/wavePYP.png')] bg-[position:left_-7px]  bg-no-repeat  
       
     hidden  lg:max-w-[260px] mid:max-w-[291px] w-full bg-brand-lightBlue h-fit pl-[22px] pr-[60px] pt-[50px] pb-[60px] clip-path-mobileClipPolygonTopRight`}
      >
        <ul>
          {Array.from({ length: totalSteps }, (_, index) => (
            <li className="flex items-start" key={index}>
              <div className="flex flex-col items-center">
                {activeStep > index ? (
                  <div
                    className="hover:cursor-pointer h-fit"
                    onClick={() => {
                      setActiveStep(index);
                    }}
                  >
                    <VerifiedIcon />
                  </div>
                ) : (
                  <button
                    className={`rounded-full bg-transparent border ${
                      activeStep === index
                        ? "border-brand-bgBlack border-[0.5px]"
                        : "border-[#5D5FEF] border-[0.5px]"
                    }  h-[26px] w-[26px]`}
                  >
                    {activeStep === index && (
                      <div className="rounded-full bg-black h-3 w-3"></div>
                    )}
                  </button>
                )}

                <div
                  className={`border-l-[1px] border-[#5D5FEF] h-[90px] my-1  ${
                    index + 1 === totalSteps ? "hidden" : ""
                  }`}
                />
              </div>
              <div
                onClick={() => {
                  if (activeStep > index) setActiveStep(index);
                }}
                className="ml-3 -translate-y-[6px] hover:cursor-pointer"
              >
                <p
                  className={`font-openSans font-normal text-[20px] leading-7 ${
                    activeStep + 1 > index
                      ? "text-brand-bgBlack"
                      : "text-brand-textLightGrey"
                  }  `}
                >
                  {index + 1 == totalSteps
                    ? "Upload Documents"
                    : `Bidder ${index + 1} Details`}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
